import { Phrases } from '@shared/models/locales.model';

export default {
  ChatLogs: 'Chat logs',
  Search: 'Search...',
  NoChatsYetDescription: 'Start a conversation, and your chats will appear here.',
  NoChatHistory: 'No chat history',
  NoChatHistoryDescription: 'Your past conversations will appear here',
  NoActiveChats: 'No active chats',
  YouLabel: 'You:',
  FleetLabel: 'Fleet:',
  DriverLabel: 'Driver:',
  CustomerLabel: 'Customer:',
  Today: 'Today',
  Yesterday: 'Yesterday',
  You: 'You (Customer)',
  OriginalBid: 'Original Bid:',
  StartConversation: 'Start a conversation',
  SendMessageTo: 'Send a message to {{name}}',
  NoMessagesToShow: 'No messages to show',
  NoChatHistoryWith: 'No chat history with {{name}}',
  Price: 'Price',
  Increase: 'Increase price',
  Decrease: 'Decrease price',
  SendOffer: 'Send Offer',
  TypeMessage: 'Type a message...',
  Send: 'Send',
  CannotSendMessages: "You can't send messages in this chat",
  TryAgainLater: 'Something went wrong. Please try again later.',
  Retry: 'Retry',
  Back: 'Back',
  Close: 'Close',
  CounterOfferSent: 'Counter Offer Sent',
  NewOfferReceived: 'New Offer Received',
  OfferAccepted: 'Offer Accepted',
  OfferRejected: 'Offer Rejected',
  OfferDeactivated: 'Offer deactivated',
  YouCounterOffered: 'You counter-offered',
  WaitingForAcceptance: "Waiting for {{name}}'s acceptance",
  AcceptOffer: 'Accept offer',
  AcceptFailed: "Couldn't accept this offer. It may no longer be active.",
  Sending: 'Sending',
  Sent: 'Sent',
  NotSent: 'Not sent',
  OfferPreview: 'Offer:',
  UnreadMessages: '{{count}} unread messages',
  OfferNotSent: 'Offer not sent',
  NewMessageFrom: 'New message from {{name}}',
  NewOfferFrom: 'New offer from {{name}}',
  OfferToastBody: 'Offer: {{price}} SAR',
} as Phrases;
